import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, PopoverController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { CoPopoverSearchFilterComponent } from '../../components/co-popover-search-filter/co-popover-search-filter';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { LoginProvider } from '../../providers/login/login';

/**
 * Generated class for the CoCatalogSearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-catalog-search',
  templateUrl: 'co-catalog-search.html',
})
export class CoCatalogSearchPage {
	@ViewChild ("results") results;
  searchTerm: string;
  overdriveEnabled: boolean;
  isFilterActive:any = {searchBy: false, filterBy: false};
  filterParameters: any = {searchBy: (this.state.searchSource === 'discover' ? 'full':'any field'), filterBy: []};
  popOverFilter: any = {};

  constructor(public navCtrl: NavController, public navParams: NavParams, private state: AppState, private popoverCtrl: PopoverController, private sounds : SoundsProvider, private loginProvider : LoginProvider) {
    this.searchTerm = this.navParams.data.searchTerm;
    if(this.navParams.data.filterParameters){
      this.filterParameters = this.navParams.data.filterParameters;
      if(this.filterParameters.filterBy.length>0){
        this.isFilterActive.filterBy=true;
      }
      if(this.filterParameters.searchBy.length>0){
        this.isFilterActive.searchBy=true;
      }
    }
    this.overdriveEnabled = this.navParams.data.overdriveEnabled;
    console.log(this.overdriveEnabled);
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  presentPopover(myEvent, filterParams) {
    let customClass = '';
    this.state.mode === 'app' ? customClass = 'custom-popover-app' : customClass = 'custom-popover-desktop';
    let popover = this.popoverCtrl.create(CoPopoverSearchFilterComponent, { data: filterParams, current: this.filterParameters }, { cssClass: customClass });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(data => {
		this.isFilterActive.searchBy=false;
		this.isFilterActive.filterBy=false;

		if(data && data.filterBy){
			this.filterParameters.filterBy = data.filterBy;
			if(data.filterBy.length>0){
				this.isFilterActive.filterBy=true;
			}
		}

		if(data && data.searchBy){
			this.filterParameters.searchBy = data.searchBy;
			if(data.searchBy.length>0){
				this.isFilterActive.searchBy=true;
			}
		}
		if(data)this.results.refresh(this.filterParameters);
    });
  }
  closeCheckin(logout: Boolean) {
    if (logout) {
      this.logout();
    } else {
      this.state.nav.popToRoot();
    }
  }
  logout() {
		this.loginProvider.logout().then( done =>{
			if( done ){
				this.state.nav.popToRoot();
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/co-catalog-search/co-catalog-search.ts